import { createTheme } from "@mui/material";
// The theme specifies the color of the components, darkness of the surfaces, level of shadow, appropriate opacity of ink elements, etc.
const theme = createTheme({
  typography: {
    fontFamily: ["sajafFont", "sajafFontBold"].join(","),
  },
});

export default theme;
